/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const UpdateFeeInstanceInputJsonApiModel = {
  id: "",
  "fee-instance": {
    jsonApi: "hasOne",
    type: "fee-instances",
  },
  options: {
    jsonApi: "hasOne",
    type: "update-options",
  },
};
